export const TEST_IDS = {
  CONTAINER: "file-upload-field-container",
  BUTTON: "single-file-upload-button",
  FILE_NAME: "file-upload-field-filename",
  PROGRESS: "file-upload-field-progress",
  ERROR: "file-upload-field-error",
  INPUT: "file-upload-field-input",
  DOWNLOAD_BUTTON: "file-upload-field-download-button",
  REMOVE_FILE: "file-upload-field-remove-file"
};

export const DEFAULT_BUTTON_LABEL = "Upload file";
